import { CommonApiResponse } from "../Controllers/Types/ApiResponse";
import apiClient from "./apiClient";
import { baseURL } from "./ApiConstant";

// Get Duty holder types
export const getDutyHolderTypes = async (folderId: number) => {
  try {
    const response = await apiClient.get(
      `/api/dutyholder-type-list/${folderId}`,
    );

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    console.error("Error fetching duty holder types:", error);

    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// Get Duty holder data
export const getDutyHolderData = async (folderId: number) => {
  try {
    const response = await apiClient.get(`/api/dutyholder-data/${folderId}`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    console.error("Error fetching duty holder data:", error);

    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// Add duty holder type
export const addDutyHolderTypeAPI = async (
  folder_id: number,
  dutyholder_type_id: number,
  id: number,
  by: string,
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/dutyholder-other-add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({
        folder_id,
        dutyholder_type_id,
        id,
        by,
      }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        massage: "Duty holder added successfully",
      };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Please check your entered values",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// Update duty holder client data
export const updateDutyHolderClientDataAPI = async (
  dutyholder_data_id: number,
  client_name: string | null,
  address: string | null,
  email: string | null,
  telephone: string | null,
  work_complete_date: string | null,
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/dutyholder-client-data-update/${dutyholder_data_id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({
          client_name,
          address,
          email,
          telephone,
          work_complete_date,
        }),
      },
    );

    const data = await response.json();

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        massage: "Client details updated successfully",
      };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Please check your entered values",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// Update duty holder other data
export const updateDutyHolderOtherDataAPI = async (
  dutyholder_data_id: number,
  name: string | null,
  address: string | null,
  email: string | null,
  telephone: string | null,
  appointment_date: string | null,
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/dutyholder-other-type-data-update/${dutyholder_data_id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({
          address,
          email,
          telephone,

          name,
          appointment_date,
        }),
      },
    );

    const data = await response.json();

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        massage: "Duty holder details updated successfully.",
      };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Please check your entered values",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// Sign compliance declaration
export const signComplianceDeclarationAPI = async (
  dutyholder_data_id: number,
  declare_that: string | null,
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/compliance-declaration-sign/${dutyholder_data_id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({
          declare_that,
        }),
      },
    );

    const data = await response.json();

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        massage: "Declaration signed successfully.",
      };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Please check your entered values",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// Delete duty holder other data
export const deleteDutyHolderOtherDataAPI = async (
  dutyholder_data_id: number,
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(
      `${baseURL}/api/dutyholder-other-data-delete/${dutyholder_data_id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
      },
    );

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        massage: "Duty holder data deleted successfully.",
      };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};
